import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable()
export class PermissionService {
  private subject = new Subject<any>();

  /**
   * Add permision to subject as observer.
   * @param permissionsValue --> Permission value
   */
  addPermissions(permissionsValue) {
    this.subject.next({permissions: permissionsValue});
  }

  /**
   * Get permissions from subject.
   */
  getPermissions(): Observable<any> {
    return this.subject.asObservable();
  }
}
